module.exports = __webpack_public_path__ + "img/yinhai_header.9d1487f8.jpg";